import { motion } from "framer-motion";
import styles from "./single-line.module.scss";
import { useState } from "react";

function SingleLine() {
  return (
    <div className={styles.lineContainer}>
      <div className={styles.gradientRight} />
      <div className={styles.gradientLeft} />
      <motion.svg
        initial={{ opacity: 0, translateY: 50 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1 }}
        xmlns="http://www.w3.org/2000/svg"
        height="230"
        fill="none"
        viewBox={"0 0 1920 199"}
        preserveAspectRatio="none"
        className={styles.singleLine}
        overflow="visible">
        <path
          stroke="url(#paint0_linear_266_88)"
          strokeWidth="60"
          d="M1977.41 42.935c-258.72-38.956-311.96 19.043-607.99 98.15C998.08 240.317 424.118 40.468-50.01 48.08"
          opacity="0.8">
          <animate
            attributeName="d"
            values={`
         M1977.41 42.935c-258.72-38.956-311.96 19.043-607.99 98.15C998.08 240.317 424.118 40.468-50.01 48.08;
          M1977.41 42.935c-258.72-38.956-311.96 30.043-607.99 105.15C998.08 260.317 424.118 60.468-50.01 48.08;
          M1977.41 42.935c-258.72-38.956-311.96 19.043-607.99 98.15C998.08 240.317 424.118 40.468-50.01 48.08
        `}
            keyTimes="0; 0.5; 1"
            keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
            dur="6s"
            repeatCount="indefinite"
            calcMode="spline"
            begin="0s"
            fill="freeze"
          />
        </path>
        <defs>
          <linearGradient id="paint0_linear_266_88" x1="1900.54" x2="1735.27" y1="30.494" y2="619.633" gradientUnits="userSpaceOnUse">
            <stop stopColor="#ADF82A"></stop>
            <stop offset="0.5" stopColor="#2EBBF8"></stop>
            <stop offset=".8" stopColor="#C374EB"></stop>
          </linearGradient>
        </defs>
      </motion.svg>
    </div>
  );
}

export default SingleLine;
